module.exports = __webpack_public_path__ + "static/img/hb_47-min.9a74f83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_47-min.png
// module id = TIMd
// module chunks = 1